import classNames from "classnames";
import { useAppDispatch, useAppSelector } from "hooks/store-hooks";
import * as React from "react";
import IconUser from "ReactComponents/Shared/Icons/icon-user";
import { navigationActions, navigationSelector } from "ReactReducers/Navigation/navigation-reducer";
import { profileActions, profileSelector } from "ReactReducers/Profile/profile-reducer";
import useKeyDown from "hooks/useKeyDown";

export function NavigationProfile() {
    const isLoggedIn = useAppSelector(profileSelector.loggedIn);
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(navigationSelector.isProfileDropdownOpen);
    const buttonRef = React.useRef<HTMLButtonElement>(null);

    // Kun det login-afhængige dropdown-indhold gates bag mount.
    // Selve knappen er bruger-uafhængig og SSR'es, så den er synlig med det samme.
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => setMounted(true), []);

    const onEscape = () => {
        dispatch(navigationActions.closeProfileDropdown());
        buttonRef.current?.focus();
    };
    useKeyDown("Escape", onEscape, isOpen);

    return (
        <div className="navigation-header__service-menu__item navigation-profile" data-service-menu-profile>
            <button
                ref={buttonRef}
                type="button"
                aria-label="Menu for log ind eller opret bruger"
                aria-expanded={isOpen}
                className="button-reset navigation-header__service-menu__button"
                onClick={() => dispatch(navigationActions.toggleProfileDropdown())}
            >
                <IconUser />
            </button>
            {/* Login-afhængigt dropdown-indhold (skjult indtil klik) først efter hydrering */}
            {mounted && (isLoggedIn ? <LoggedIn /> : <NotLoggedIn />)}
        </div>
    );
}

export function LoggedIn() {
    const isOpen = useAppSelector(navigationSelector.isProfileDropdownOpen);
    const userProfile = useAppSelector(profileSelector.userInfo);
    const login = useAppSelector(profileSelector.login);

    if (!userProfile) {
        return null;
    }

    return (
        <List
            className={classNames("navigation-profile-list", {
                "navigation-profile-list--isOpen": isOpen
            })}
        >
            <>
                {userProfile.ProfileLinks?.map((link, index) => {
                    return <Item key={index} {...link} />;
                })}
                {login && <Item Text={login.LogoutUrl?.Text} Url={login.LogoutUrl?.FullUrl} />}
            </>
        </List>
    );
}

export function NotLoggedIn() {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(navigationSelector.isProfileDropdownOpen);
    const login = useAppSelector(profileSelector.login);

    if (!login) {
        return null;
    }

    return (
        <List
            {...login}
            className={classNames("navigation-profile-list", {
                "navigation-profile-list--isOpen": isOpen
            })}
        >
            {login.LoginUrl && (
                <Item onClick={() => dispatch(profileActions.userLogin())} Text={login.LoginUrl.Text} />
            )}
            <Item {...login.CreateProfileUrl} />
        </List>
    );
}

export function List(props: { className?: string; children: React.ReactNode }) {
    return (
        <div className={props.className}>
            <ul>{props.children}</ul>
        </div>
    );
}

export function Item(props: { Text?: string; Url?: string; onClick?(): void; className?: string }) {
    if (props.onClick) {
        return (
            <li>
                <button
                    type="button"
                    className={classNames("button-reset", props.className)}
                    onClick={props.onClick}
                >
                    {props.Text}
                </button>
            </li>
        );
    }

    return (
        <li className={props.className}>
            <a href={props.Url}>{props.Text}</a>
        </li>
    );
}
